import { render, staticRenderFns } from "./ApprovalLevel3.vue?vue&type=template&id=5e651ffb&scoped=true"
import script from "./ApprovalLevel3.vue?vue&type=script&lang=js"
export * from "./ApprovalLevel3.vue?vue&type=script&lang=js"
import style0 from "./ApprovalLevel3.vue?vue&type=style&index=0&id=5e651ffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e651ffb",
  null
  
)

export default component.exports